export const customPageLinkRouteNames = {
 default:'location-custom-page-link-v2'
}
